module.exports = __webpack_public_path__ + "img/ios-attach2.2ce9c830.svg";